import { Link, useLocation } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { Button, ConfigProvider, Layout } from 'antd';
import './index.css';

import Menu from '../common/Menu';
import MenuItem from '../common/MenuItem';
import DrawerComponent from '../common/Drawer';
import { ConfigConsumerProps } from 'antd/lib/config-provider';
import { useMediaQuery } from '../../hooks/MediaQuery.hook';
import { MailOutlined, MenuOutlined } from '@ant-design/icons';
import { CATGORY_LINKS } from '../../utils/constant';
import logo from '../../assets/logo/logo.webp';

const { Header } = Layout;

const styles = {
  headerHamburger: (themeConfig: ConfigConsumerProps) => ({
    color: themeConfig?.theme?.token?.colorPrimary,
  }),
  headerDrawer: {
    width: 'auto',
    borderRight: 'none',
  },
  displayFlex: {
    display: 'flex',
    justifyContent: 'space-between',
  }
};

export default function HeaderComponent() {
  const location = useLocation();
  const [headerDrawerOpen, setHeaderDrawerOpen] = useState<boolean>(false);
  const matches = useMediaQuery('(min-width: 1000px)');
  const [urlIndex, setUrlIndex] = useState<string[]>(['-1']);
  const themeConfiguration = useContext(ConfigProvider.ConfigContext);

  useEffect(() => {
    // Find the index of the current path in CATGORY_LINKS
    const currentIndex = CATGORY_LINKS.findIndex(cat => cat.link === location.pathname);
    
    // If found, update urlIndex with the found index
    if (currentIndex !== -1) {
      setUrlIndex([currentIndex.toString()]);
    } else {
      setUrlIndex(['-1']); // Default index if the path doesn't match any
    }
  }, [location.pathname]);

  const MenuItems = (
    <>
      {CATGORY_LINKS?.map((cat: any, index: any) => (
        <MenuItem key={index}>
          <Link className='menu-items' to={cat?.link} >{cat.label}</Link>
        </MenuItem>
      ))}
    </>
  );

  return (
    <Header
      style={{display: 'flex', justifyContent: matches ? 'space-between': 'center'}}
    >
      <div className='header-body'>
        {!matches && (
          <div onClick={() => setHeaderDrawerOpen(true)}>
            <MenuOutlined style={{...styles.headerHamburger(themeConfiguration), color:'#fff'}} />
          </div>
        )}
        <Link to='/'>
          <div style={{ display: 'flex', justifyContent: 'center', height: '100%' }}>
            <img src={logo} className='logo-img' alt='Koostream logo' />
          </div>
        </Link>
        {matches && (
          <Menu mode='horizontal' selectedKeys={urlIndex} style={{ width: '100%', background: '#111111' }}>
            {MenuItems}
          </Menu>
        )}
      </div>
      <div style={{display: 'flex', justifyContent: 'right'}}>
        <Link to='/blogs' style={{paddingRight: '10px'}}>
          <Button shape='round' size={matches ? 'middle': 'small'} style={{background: '#111111', color: '#ffffff',}}>
            Blogs
          </Button>
        </Link>
        <Link to='/contact-us'>
          {matches ? 
            <Button shape="round" style={{background: '#111111', color: '#ffffff'}}>
              Contact
            </Button> :
            <MailOutlined style={{ color: '#f0f0f0', marginLeft: '10px' }} />
          }
        </Link>
      </div>
      <DrawerComponent
        title='koostream'
        open={headerDrawerOpen}
        onClose={() => setHeaderDrawerOpen(false)}
      >
        <Menu
          onClick={() => setHeaderDrawerOpen(false)}
          mode='vertical'
          selectedKeys={urlIndex}
          style={styles.headerDrawer}
        >
          {MenuItems}
        </Menu>
      </DrawerComponent>
    </Header>
  );
}
